import { useState } from 'react';
import { Check, Loader2, X } from 'lucide-react';
import { GOAL_STATUSES } from '../lib';
import { Field } from '../bits';

export function ReviewForm({ goal, onSubmit, onCancel }) {
  const [status, setStatus] = useState(goal.status);
  const [moved, setMoved] = useState('');
  const [risks, setRisks] = useState('');
  const [note, setNote] = useState('');
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    if (!(moved.trim() || risks.trim() || note.trim())) return;
    setBusy(true);
    const ok = await onSubmit({ status, moved: moved.trim(), risks: risks.trim(), note: note.trim() });
    setBusy(false);
    if (ok) onCancel();
  };
  return (
    <div className="rounded-xl p-4 flex flex-col gap-3" style={{ background: 'var(--sage-soft)' }} data-testid="ws-review-form">
      <p className="text-sm font-semibold" style={{ color: 'var(--sage-deep)' }}>Review sit-down</p>
      <Field label="What moved since last time?"><textarea value={moved} onChange={(e) => setMoved(e.target.value)} rows={2} className="biz-input resize-none" autoFocus data-testid="ws-review-moved" /></Field>
      <Field label="What’s at risk or stuck?"><textarea value={risks} onChange={(e) => setRisks(e.target.value)} rows={2} className="biz-input resize-none" data-testid="ws-review-risks" /></Field>
      <Field label="Anything else"><input value={note} onChange={(e) => setNote(e.target.value)} className="biz-input" data-testid="ws-review-note" /></Field>
      <div>
        <p className="text-xs font-semibold mb-1.5" style={{ color: 'var(--ink-3)' }}>Verdict</p>
        <div className="flex flex-wrap gap-1.5">
          {Object.entries(GOAL_STATUSES).map(([k, v]) => <button key={k} type="button" onClick={() => setStatus(k)} className="biz-chip transition-opacity" style={{ background: v.bg, color: v.fg, opacity: status === k ? 1 : 0.45, outline: status === k ? '2px solid var(--ink)' : 'none' }} data-testid={`ws-review-status-${k}`}>{v.label}</button>)}
        </div>
      </div>
      <div className="flex justify-end gap-2">
        <button type="button" onClick={onCancel} className="biz-btn text-xs py-1.5"><X className="w-3.5 h-3.5" /> Cancel</button>
        <button type="button" onClick={submit} disabled={busy} className="biz-btn biz-btn-primary text-xs py-1.5" data-testid="ws-review-submit">{busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Check className="w-3.5 h-3.5" />} File review & book the next</button>
      </div>
    </div>
  );
}
